<template>
  <Transition
    enter-active-class="transition-all duration-300 ease-out"
    enter-from-class="opacity-0 transform translate-y-2 scale-95"
    enter-to-class="opacity-100 transform translate-y-0 scale-100"
    leave-active-class="transition-all duration-200 ease-in"
    leave-from-class="opacity-100 transform translate-y-0 scale-100"
    leave-to-class="opacity-0 transform translate-y-2 scale-95"
  >
    <div
      v-if="visible"
      :style="{
        top: (96 + (props.offsetIndex || 0) * 80) + 'px',
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
      }"
      :class="[
        'fixed right-4 z-[9999] max-w-sm w-full',
        'bg-white rounded-lg shadow-lg border-l-4 p-4',
        type === 'success' ? 'border-green-500' : type === 'warning' ? 'border-yellow-500' : type === 'modifier' ? 'border-blue-500' : 'border-red-500',
      ]"
    >
      <div class="flex items-start">
        <div class="flex-shrink-0">
          <div
            :class="[
              'w-6 h-6 rounded-full flex items-center justify-center text-white',
              type === 'success' ? 'bg-green-500' : type === 'warning' ? 'bg-yellow-500' : type === 'modifier' ? 'bg-blue-500' : 'bg-red-500',
            ]"
          >
            <i
              :class="
                type === 'success' ? 'fas fa-check' : type === 'warning' ? 'fas fa-exclamation-triangle' : type === 'modifier' ? 'fas fa-pencil-alt' : 'fas fa-exclamation'
              "
              class="text-xs"
            ></i>
          </div>
        </div>
        <div class="ml-3 w-0 flex-1">
          <p class="text-sm font-medium text-gray-900">
            {{
              type === "success"
                ? "Sauvegardé avec succès !"
                : type === "warning"
                ? "Avertissement"
                : type === "modifier"
                ? "Modification"
                : "Erreur lors de la sauvegarde"
            }}
          </p>
          <p class="mt-1 text-sm text-gray-500">
            {{ message }}
          </p>
        </div>
        <div class="ml-4 flex-shrink-0 flex">
          <button
            @click="close"
            class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-600 focus:outline-none"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import type { NotificationProps } from "@/types";

const props = withDefaults(defineProps<NotificationProps>(), {
  duration: 3000,
  offsetIndex: 0,
});

const emit = defineEmits<{
  close: [];
}>();

const visible = ref(false);

onMounted(() => {
  visible.value = true;

  setTimeout(() => {
    close();
  }, props.duration);
});

function close() {
  visible.value = false;
  setTimeout(() => {
    emit("close");
  }, 500);
}
</script>
